module.exports = __webpack_public_path__ + "static/media/alena_thumb_wide.9c9c611f.webp";